import {d as n} from '@theme/global';
import '@theme/request-idle-callback';
class h extends HTMLElement {
  constructor() {
    super(),
      (this.cachedResults = {}),
      (this.input = this.querySelector('input[type="search"]')),
      (this.predictiveSearchResults = this.querySelector('[data-predictive-search]')),
      (this.isOpen = !1),
      this.setupEventListeners();
  }
  setupEventListeners() {
    this.querySelector('form.search').addEventListener('submit', this.onFormSubmit.bind(this)),
      this.input.addEventListener(
        'input',
        n((s) => {
          this.onChange(s);
        }, 300).bind(this)
      ),
      this.input.addEventListener('focus', this.onFocus.bind(this)),
      this.addEventListener('focusout', this.onFocusOut.bind(this)),
      this.addEventListener('keyup', this.onKeyup.bind(this)),
      this.addEventListener('keydown', this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    const e = this.getQuery();
    if (!e.length) {
      this.close(!0);
      return;
    }
    this.getSearchResults(e);
  }
  onFormSubmit(e) {
    (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) && e.preventDefault();
  }
  onFocus() {
    const e = this.getQuery();
    e.length && (this.getAttribute('results') === 'true' ? this.open() : this.getSearchResults(e));
  }
  onFocusOut() {
    setTimeout(() => {
      this.contains(document.activeElement) || this.close();
    });
  }
  onKeyup(e) {
    switch ((this.getQuery().length || this.close(!0), e.preventDefault(), e.code)) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }
  onKeydown(e) {
    (e.code === 'ArrowUp' || e.code === 'ArrowDown') && e.preventDefault();
  }
  switchOption(e) {
    if (!this.getAttribute('open')) return;
    const s = e === 'up',
      t = this.querySelector('[aria-selected="true"]'),
      i = this.querySelectorAll('li');
    let r = this.querySelector('li');
    (s && !t) ||
      ((this.statusElement.textContent = ''),
      !s && t ? (r = t.nextElementSibling || i[0]) : s && (r = t.previousElementSibling || i[i.length - 1]),
      r !== t &&
        (r.setAttribute('aria-selected', !0),
        t && t.setAttribute('aria-selected', !1),
        this.setLiveRegionText(r.textContent),
        this.input.setAttribute('aria-activedescendant', r.id)));
  }
  selectOption() {
    const e = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
    e && e.click();
  }
  getSearchResults(e) {
    const s = e.replace(' ', '-').toLowerCase();
    if ((this.setLiveRegionLoadingState(), this.cachedResults[s])) {
      this.renderSearchResults(this.cachedResults[s]);
      return;
    }
    const limit = Math.max(1, Math.min(6, Number.parseInt(window.theme?.searchSettings?.limit, 10) || 6));
    fetch(
      `${window.routes.predictive_search_url}?q=${encodeURIComponent(e)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=${limit}&section_id=predictive-search`
    )
      .then((t) => {
        if (!t.ok) {
          const i = new Error(t.status);
          throw (this.close(), i);
        }
        return t.text();
      })
      .then((t) => {
        const i = new DOMParser()
          .parseFromString(t, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        (this.cachedResults[s] = i), this.renderSearchResults(i);
      })
      .catch((t) => {
        throw (this.close(), t);
      });
  }
  setLiveRegionLoadingState() {
    (this.statusElement = this.statusElement || this.querySelector('.predictive-search-status')),
      (this.loadingText = this.loadingText || this.getAttribute('data-loading-text')),
      this.setLiveRegionText(this.loadingText),
      this.setAttribute('loading', !0);
  }
  setLiveRegionText(e) {
    this.statusElement.setAttribute('aria-hidden', 'false'),
      (this.statusElement.textContent = e),
      setTimeout(() => {
        this.statusElement.setAttribute('aria-hidden', 'true');
      }, 1e3);
  }
  renderSearchResults(e) {
    (this.predictiveSearchResults.innerHTML = e),
      this.setAttribute('results', !0),
      this.setLiveRegionResults(),
      this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute('loading'),
      this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }
  getResultsMaxHeight() {
    return (
      (this.resultsMaxHeight =
        window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom),
      this.resultsMaxHeight
    );
  }
  open() {
    (this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`),
      this.setAttribute('open', !0),
      this.input.setAttribute('aria-expanded', !0),
      (this.isOpen = !0);
  }
  close(e = !1) {
    e && ((this.input.value = ''), this.removeAttribute('results'));
    const s = this.querySelector('[aria-selected="true"]');
    s && s.setAttribute('aria-selected', !1),
      this.input.setAttribute('aria-activedescendant', ''),
      this.removeAttribute('open'),
      this.input.setAttribute('aria-expanded', !1),
      (this.resultsMaxHeight = !1),
      this.predictiveSearchResults.removeAttribute('style'),
      (this.isOpen = !1);
  }
}
customElements.get('predictive-search') || customElements.define('predictive-search', h);
